<template>
  <div>
    <To :to="data.to" @updateTo="data.to = $event"></To>
    <File :file="data.audio" @updateFile="data.audio = $event"></File>
    <Caption :text="data.caption" @updateCaption="data.caption=$event"></Caption>
    <ReplyMarkup :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup=$event"></ReplyMarkup>
  </div>
</template>


<script>
import Caption from '@/components/tasks/fields/Caption.vue'
import ReplyMarkup from '@/components/tasks/fields/ReplyMarkup.vue'
import To from '@/components/tasks/fields/To.vue'
import File from '@/components/tasks/fields/File.vue'



export default {
  name: 'SendAudio',
  components:{
    Caption,
    ReplyMarkup,
    To,
    File
  },
  props: {
    data: Object,
    actions: Object
  },
  methods:{
    
  },


}
</script>
